"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FrequencyTable = _interopRequireDefault(require("./FrequencyTable.js"));
var _SummaryTable = _interopRequireDefault(require("./SummaryTable.js"));
var _cccisdVisualize = require("cccisd-visualize");
var _color = _interopRequireDefault(require("color"));
var _isNumericString = _interopRequireDefault(require("../isNumericString.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Content = function Content(props) {
  var currentMetric = props.currentMetric,
    currentMetricSettings = props.currentMetricSettings,
    data = props.data;
  var _useMemo = (0, _react.useMemo)(function () {
      var metricCoding = currentMetric.enumCoding ? Object.entries(currentMetric.enumCoding).reduce(function (obj, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        obj[value] = key;
        return obj;
      }, {}) : null;
      var rows = data.frequency.filter(function (item) {
        return item.value;
      }).map(function (item) {
        return _objectSpread({
          value: Number(item.valueCount),
          label: currentMetric.enumCoding ? metricCoding[item.value] : item.value
        }, currentMetric.enumCoding ? {
          code: item.value
        } : {});
      });
      var frequency = function () {
        var result = _toConsumableArray(rows);
        if (currentMetric.enumCoding) {
          var existingLabels = result.reduce(function (obj, item) {
            obj.add(item.label);
            return obj;
          }, new Set());
          for (var _i = 0, _Object$entries = Object.entries(currentMetric.enumCoding); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              label = _Object$entries$_i[0],
              code = _Object$entries$_i[1];
            if (!existingLabels.has(label)) {
              result.push({
                value: 0,
                label: label,
                code: code
              });
            }
          }
        }
        var allowRollup = currentMetricSettings.chartType !== 'none';
        var rollupThreshold = allowRollup && currentMetricSettings.enableRollupThreshold ? currentMetricSettings.rollupThresholdValue : 0;
        if (rollupThreshold > 0 && result.length > rollupThreshold + 1) {
          result.sort(function (a, b) {
            if (b.value !== a.value) {
              return b.value - a.value;
            }
            if (typeof a.label === 'string' && typeof b.label === 'string') {
              return a.label.localeCompare(b.label);
            }
            return 0;
          });
          var otherTotal = result.length - rollupThreshold;
          var otherSum = result.slice(rollupThreshold).reduce(function (num, item) {
            return num + item.value;
          }, 0);
          result = result.slice(0, rollupThreshold);
          result.push({
            label: "".concat(otherTotal, " others"),
            value: otherSum,
            isOthers: true
          });
        } else if (currentMetric.enumCoding) {
          // Sort by enum order
          var order = currentMetric.content.enumDisplayText.reduce(function (obj, item, index) {
            obj[item] = index;
            return obj;
          }, {});
          result.sort(function (a, b) {
            return order[a.label] - order[b.label];
          });
        } else if (currentMetric.type === 'formula' && result.every(function (item) {
          return (0, _isNumericString["default"])(item.label);
        })) {
          result.sort(function (a, b) {
            return Number(a.label) - Number(b.label);
          });
        }
        return result;
      }();
      var summary = function () {
        if (!currentMetric.hasSummary) {
          return null;
        }
        if (!currentMetricSettings.showSummaryStats) {
          return null;
        }
        var min = Infinity;
        var max = -Infinity;
        var _iterator = _createForOfIteratorHelper(rows),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            var value = Number(currentMetric.enumCoding ? item.code : item.label);
            if (value < min) {
              min = value;
            }
            if (value > max) {
              max = value;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return [{
          label: 'Mean',
          value: data.avg
        }, {
          label: 'Stddev',
          value: data.stddev
        }, {
          label: 'Min',
          value: min
        }, {
          label: 'Max',
          value: max
        }];
      }();
      var chart = function () {
        if (currentMetricSettings.chartType === 'bar') {
          return frequency.map(function (item) {
            return {
              id: item.label,
              responses: item.value
            };
          });
        }
        if (currentMetricSettings.chartType === 'line') {
          return [{
            id: 'Responses',
            data: frequency.map(function (item) {
              return {
                x: item.label,
                y: item.value
              };
            })
          }];
        }
        if (currentMetricSettings.chartType === 'pie') {
          return frequency.map(function (item) {
            return {
              id: item.label,
              label: item.label,
              value: item.value
            };
          });
        }
        return [];
      }();
      return {
        frequencyData: frequency,
        summaryData: summary,
        chartData: chart
      };
    }, [currentMetric, data, currentMetricSettings]),
    frequencyData = _useMemo.frequencyData,
    summaryData = _useMemo.summaryData,
    chartData = _useMemo.chartData;
  var showPercentage = currentMetric.type !== 'qualitative';
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].list
  }, currentMetricSettings.chartType === 'bar' && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Bar, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.bar), {}, {
      keys: ['responses'],
      labelSkipHeight: 0,
      label: function label(d) {
        return d.value === 0 ? /*#__PURE__*/_react["default"].createElement("tspan", {
          y: "-12"
        }, d.value) : d.value;
      },
      tooltipLabel: function tooltipLabel(datum) {
        return datum.indexValue;
      },
      labelTextColor: function labelTextColor(item) {
        var value = item.data.value;
        var color = (0, _color["default"])(item.color).hsl();
        var lightness = color.color[2];
        var newLightness = lightness > 60 ? Math.min(lightness - 60, 20) : 100;
        if (value === 0 && newLightness > 80) {
          newLightness = 20;
        }
        return color.lightness(newLightness).hex();
      }
    })
  })), currentMetricSettings.chartType === 'line' && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Line, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.line), {}, {
      keys: ['responses']
    })
  })), currentMetricSettings.chartType === 'pie' && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      height: "".concat(currentMetricSettings.chartHeight || 500, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdVisualize.Pie, {
    data: chartData,
    settings: _objectSpread(_objectSpread({}, currentMetricSettings.nivoOptions.pie), {}, {
      keys: ['responses']
    })
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].tables
  }, currentMetricSettings.showTable ? /*#__PURE__*/_react["default"].createElement(_FrequencyTable["default"], {
    data: frequencyData,
    showPercentage: showPercentage
  }) : null, currentMetric.hasSummary && currentMetricSettings.showSummaryStats ? /*#__PURE__*/_react["default"].createElement(_SummaryTable["default"], {
    data: summaryData
  }) : null));
};
Content.propTypes = {
  currentMetric: _propTypes["default"].object,
  currentMetricSettings: _propTypes["default"].object,
  data: _propTypes["default"].object
};
var _default = exports["default"] = Content;